import React, {Component} from "react";

import LoaderButton from "../components/LoaderButton";
import { Auth, API } from "aws-amplify";
import Confirmation from "./Confirmation";
import "./RetnetRegister.css"

export default class RetnetRegister extends Component {
  constructor(props){
    super(props);
    this.paynow = React.createRef();

    this.state = {


    };
  }

  validateForm() {

  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }


  render(){
    return(
      <div className="container-fluid">


          <div className="row" hidden>

              <div className="col-md-8">

                  <div className="container d-flex">
                      <div className="row cols-xs-space cols-sm-space text-center">

                          <div className="col-12 col-lg-10 holder-item-light">
                              <img className="retnet-banner" src="/images/RETNETFlyer1.JPG" height="500px" />


                            <a href="https://form.jotform.com/200200565419445" className="btn btn-success text-uppercase btn-circle retnet-btn" >
                                           SUBMIT YOUR PRESENTATION
                                </a>
                                <a href="/register4retnet" className="btn btn-success text-uppercase btn-circle retnet-btn">
                                              REGISTER FOR RETNET-2020
                               </a>
                          </div>

                      </div>


                  </div>
              </div>
              <div className="col-md-4">

                  <img className="retnet-banner" src="/images/preconferenceworkshop2.png" />

              </div>


          </div>

          <div className="row">

              <div className="card  retnet-price-box ">
                  <div className="card-body retnet-center-text">
                      <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference only <br/> <br/> <br /></h5>
                      <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;5,000</h3>
                      <h6 className="retnet-center-text">per person</h6> <br/>

                      <a className="btn btn-success" href="/conference">Register Now</a>

                  </div>
                  Charges Includes:
                  <ul >
                      <li>Conference Registration</li>
                      <li>June 8th - Lunch & Dinner</li>
                      <li>June 9th - Breakfast & Lunch</li>
                      <br/>
                      <br/>


                  </ul>
              </div>
              <div className="card  retnet-price-box ">
                  <div className="card-body retnet-center-text">
                      <h5 className="heading heading-5 strong-600 retnet-center-text text-primary ">Retnet India Conference Live Web Link<br/> <br/> </h5>
                      <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;3,000</h3>
                      <h6 className="retnet-center-text">per person</h6> <br/>
                      <btn className="btn btn-success" onClick={()=>{ this.paynow.current.click() }}>Register Now</btn>
                      <div hidden>
                          <a href="https://www.instamojo.com/@retnetindia/l2fc4565e78b049939f17fd732cf827d6/"
                             rel="im-checkout" data-behaviour="remote"  ref={this.paynow}
                             data-style="light" data-text="Checkout With Instamojo" hidden>
                          </a>
                      </div>
                  </div>

                  <ul >
                      <li className="text-primary">Web Link will be emailed a day before to view the conference Live</li>
                      <br/>
                      <br/>
                      <br/>


                  </ul>
              </div>

              <div className="card  retnet-price-box ">
                  <div className="card-body retnet-center-text">
                      <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference <br/> + <br/> Single Occupancy Room</h5>
                      <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;10,500</h3>
                      <h6 className="retnet-center-text">per person</h6> <br/>
                      <btn className="btn btn-warning"  >Registrations Closed</btn>
                      <h6 className="red-font">Rooms Full</h6>

                  </div>
                  Charges Includes:
                  <ul >
                      <li>Conference Registration</li>
                      <li>Hotel Check in June 8th at 2pm</li>
                      <li>Hotel Check out June 9th by 12pm </li>
                      <li>June 8th - Lunch & Dinner</li>
                      <li>June 9th - Breakfast & Lunch</li>

                  </ul>
              </div>




          </div>
          <br />

          <div className="row">


              <div className="card  retnet-price-box ">
                  <div className="card-body retnet-center-text">
                      <h5 className="heading heading-5 strong-600 retnet-center-text">Retnet India Conference <br /> + <br/> Double Occupancy Room</h5>
                      <h3 className="price-tag retnet-center-text retnet-no-padding">&#x20B9;8,000</h3>
                      <h6 className="retnet-center-text">per person</h6> <br/>
                      <btn className="btn btn-warning"  >Registrations Closed</btn>
                      <h6 className="red-font">Rooms Full</h6>

                  </div>
                  Charges Includes:
                  <ul >
                      <li>Conference Registration</li>
                      <li>Hotel Check in June 8th at 2pm</li>
                      <li>Hotel Check out June 9th by 12pm </li>
                      <li>June 8th - Lunch & Dinner</li>
                      <li>June 9th - Breakfast & Lunch</li>

                  </ul>
              </div>



          </div>



          <br />
          <br />



      </div>



    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/RetnetRegister.js